module.exports = __webpack_public_path__ + "public/SiteIcons/verifiGoogle.png?10772a36";